module.exports = __webpack_public_path__ + "33a93d2e8671e3c17d630abf93f39e33.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/minimal-wave-hat.jpg
 ** module id = 453
 ** module chunks = 0
 **/